import axios from "axios";
import { withTimeout } from "../utils/promiseTimeout";

const ADMIN_PRODUCT_GROUPS_URL =
  "https://asia-southeast1-mailcinemaotp.cloudfunctions.net/getAdminProductGroups";
const SESSION_CACHE_KEY = "cinema.admin.productGroups.v1";
// PWA may be reopened after iOS has suspended every network connection.
// Keep the last valid product list available for immediate rendering, then
// refresh it in the background when the admin page becomes active.
const SESSION_CACHE_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

function isValidProductGroups(value) {
  return Array.isArray(value) && value.every((item) => item?.key);
}

export function readAdminProductGroupsCache() {
  for (const storage of [window.sessionStorage, window.localStorage]) {
    try {
      const cached = JSON.parse(storage.getItem(SESSION_CACHE_KEY));
      if (
        cached &&
        isValidProductGroups(cached.data) &&
        Date.now() - Number(cached.savedAt || 0) <= SESSION_CACHE_MAX_AGE_MS
      ) {
        return cached.data;
      }
    } catch (error) {
      console.debug("Admin product cache unavailable:", error?.message);
    }
  }

  return [];
}

export function writeAdminProductGroupsCache(data) {
  const serialized = JSON.stringify({ data, savedAt: Date.now() });
  for (const storage of [window.sessionStorage, window.localStorage]) {
    try {
      storage.setItem(SESSION_CACHE_KEY, serialized);
    } catch (error) {
      console.debug("Admin product cache write skipped:", error?.message);
    }
  }
}

export async function loadAdminProductGroups(user, { timeoutMs = 8000 } = {}) {
  if (!user) throw new Error("Authentication required");

  const token = await withTimeout(
    user.getIdToken(),
    "ตรวจสอบสิทธิ์ผู้ดูแลระบบใช้เวลานานเกินไป",
    5000,
  );
  const response = await axios.post(
    ADMIN_PRODUCT_GROUPS_URL,
    {},
    {
      timeout: timeoutMs,
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  if (!response.data?.success || !isValidProductGroups(response.data.data)) {
    throw new Error(response.data?.message || "โหลดรายการสินค้าไม่สำเร็จ");
  }

  writeAdminProductGroupsCache(response.data.data);
  return response.data.data;
}
